import $ from 'jquery';

let handheldNavigationToggle = {
    initialize: function () {

      let $body = $('body');
      $('[data-handheld-navigation-toggle]').on('click', function (event) {
        event.preventDefault();

        let $toggle = $(this);

        if ($body.hasClass('o-body--handheld-navigation-visible')) {
          $body.removeClass('o-body--handheld-navigation-visible');
          $toggle.attr('aria-expanded', 'false');
        } else {
          document.body.style.setProperty(
            '--scrollbar-width',
            (window.innerWidth - document.documentElement.clientWidth) + 'px'
          );
          $body.addClass('o-body--handheld-navigation-visible');
          $toggle.attr('aria-expanded', 'true');
        }
      });
    }

  };

handheldNavigationToggle.initialize();
